import { clearAtlasAssetToken } from "@/modules/atlas-asset-token/clear-token";
import { getAtlasAssetToken } from "@/modules/atlas-asset-token/get-token";
import { setAtlasAssetToken } from "@/modules/atlas-asset-token/set-token";
import { moduleFactory } from "@/factories/module";

export const atlasAssetTokenModule = moduleFactory.create({
  getToken: getAtlasAssetToken,
  setToken: setAtlasAssetToken,
  clearToken: clearAtlasAssetToken,
});
